import _ from 'lodash'
import React from 'react'

import { Page, Typography } from 'components'

import i18n from 'translations'

import { MarketPlaceProps } from './AppMarketplaceConstants'
import { StyledGridContainer } from './AppMarketplaceStyled'
import AppMarketplaceCard from './components/AppMarketplaceCard'

interface AppMarketplaceViewProps {
  marketPlaceData: MarketPlaceProps[]
}

const AppMarketplaceView: React.FC<AppMarketplaceViewProps> = ({
  marketPlaceData,
}) => (
  <Page.Section title={i18n.t('module:AppMarketplace:title')}>
    <Typography>
      {i18n.t('module:AppMarketplace:subtitle')}
    </Typography>
    <StyledGridContainer>
      {_.map(marketPlaceData, (marketPlaceItem: MarketPlaceProps, index) => (
        <AppMarketplaceCard
          appLogo={marketPlaceItem.appLogo}
          appName={marketPlaceItem.appName}
          description={marketPlaceItem.description}
          isStatusLoading={marketPlaceItem.isStatusLoading}
          key={`${marketPlaceItem.appType}_${index}`}
          specialOfferText={marketPlaceItem.specialOfferText}
          status={marketPlaceItem.status}
          title={marketPlaceItem.title}
          titleColor={marketPlaceItem.titleColor}
          to={marketPlaceItem.to}
        />
      ))}
    </StyledGridContainer>
  </Page.Section>
)

export default AppMarketplaceView
